import { TFunction } from "i18next";

const TRANSLATION_PREFIX = "deals.dealView.stakeholdersApprovalEmpty";

/** Translated empty-state copy, naming the questionnaire the button opens. */
export const stakeholdersApprovalLabels = (
  t: TFunction<"translation", undefined>,
  questionnaireName?: string
) => ({
  title: t(`${TRANSLATION_PREFIX}.title`),
  subtitle: t(`${TRANSLATION_PREFIX}.subtitle`),
  button: t(`${TRANSLATION_PREFIX}.button`, {
    stakeholdersMappingWorkflowName: questionnaireName || ""
  })
});
